import { render, staticRenderFns } from "./StatementSelectorTabs.vue?vue&type=template&id=7213fb22&scoped=true&"
import script from "./StatementSelectorTabs.vue?vue&type=script&lang=ts&"
export * from "./StatementSelectorTabs.vue?vue&type=script&lang=ts&"
import style0 from "./StatementSelectorTabs.vue?vue&type=style&index=0&id=7213fb22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7213fb22",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VRadio,VRadioGroup,VSpacer,VSwitch,VTab,VTabItem,VTextField})
